import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const SAVED_CART_MANAGER_DIALOG_NAME = 'SavedCartManagerDialog';
export const SAVED_CART_MANAGER_DIALOG_SLOTS: Array<
	keyof SavedCartManagerDialogClasses
> = ['root'] as const;

export type SavedCartManagerDialogSlot =
	(typeof SAVED_CART_MANAGER_DIALOG_SLOTS)[number];

export interface SavedCartManagerDialogClasses {
	root: string;
}

export type SavedCartManagerDialogClassKey =
	keyof SavedCartManagerDialogClasses;

export const getSavedCartManagerDialogUtilityClass = (slot: string) =>
	generateUtilityClass(
		SAVED_CART_MANAGER_DIALOG_NAME,
		slot as SavedCartManagerDialogSlot,
	);

export const savedCartManagerDialogClasses: SavedCartManagerDialogClasses =
	generateUtilityClasses(SAVED_CART_MANAGER_DIALOG_NAME, ['root']);

export default savedCartManagerDialogClasses;
